import { ITender } from 'types/tender';
import { useCallback, useEffect, useState } from 'react';
import { hasTenderPassedStartDate } from 'utils/tender';

export function useTenderPassedStartTime(tender?: ITender) {
  const [passedStartDate, setPassedStartDate] = useState(false);

  const checkStartDate = useCallback(() => {
    if (tender?.startTime) {
      setPassedStartDate(hasTenderPassedStartDate(tender))
    }
  }, [tender?.startTime])

  useEffect(() => {
    const intervalId = setInterval(checkStartDate, 1000);

    return () => {
      clearInterval(intervalId)
    }
  }, [checkStartDate])

  return passedStartDate;
}
